import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable({
    providedIn: 'root'
})
export class AppConfig
{
    static settings: IAppConfig;
    constructor(private http: HttpClient)
    {
    }

    load() {
        const jsonFile = 'pns.config.json';
        const browserWindow = window || {};
        const browserWindowEnv = browserWindow['__env'] || {};
        AppConfig.settings={
            clientId: browserWindowEnv.clientId,
            tenant: browserWindowEnv.tenant,
            resource: browserWindowEnv.resource,
            endpoints: browserWindowEnv.endpoints,
           // redirectUri: browserWindowEnv.redirectUri
        };
        return AppConfig.settings;
    }
}

export interface IAppConfig
{
        tenant:any,
        clientId:any,
        resource:any,
        endpoints:any,
        redirectUri?: any
}
